import React from 'react'
import { Wrapper } from 'lib/noop-wrapper'
import getContentJumpUrl from 'lib/get-content-jump-url'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'

export interface IAnyLinkParams {
  id: string
  articleType?: number
  title?: string
  queryParams?: { [key: string]: number | string }
}

function anyLink({
  id,
  articleType,
  title,
  queryParams,
}: IAnyLinkParams): Wrapper {
  let link = getContentJumpUrl(id, articleType)

  if (queryParams) {
    link += `?${serializeObject(queryParams)}`
  }

  return (content) =>
    link ? (
      <React.Fragment>
        <a title={title} href={link} target={'_blank'}>
          {content}
        </a>
        <style jsx>
          {`
            a {
              color: inherit;
            }
          `}
        </style>
      </React.Fragment>
    ) : (
      content
    )
}

export default anyLink
